import { render, staticRenderFns } from "./update-details-ticket-my-account.vue?vue&type=template&id=ed7c94e6&scoped=true"
import script from "./update-details-ticket-my-account.vue?vue&type=script&lang=ts"
export * from "./update-details-ticket-my-account.vue?vue&type=script&lang=ts"
import style0 from "./update-details-ticket-my-account.vue?vue&type=style&index=0&id=ed7c94e6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7c94e6",
  null
  
)

export default component.exports